module.exports = __webpack_public_path__ + "static/media/reparaciones.5a17d921.png";